import { Head } from "vite-react-ssg";

const SITE_URL = "https://jivaseva.com";
const OG_IMAGE = `${SITE_URL}/jivaseva-logo.png`;

interface Props {
  /** Full document title, e.g. "About · JivaSeva". */
  title: string;
  /** ~150-char meta description unique to the page. */
  description: string;
  /** Absolute route path, e.g. "/about" — used for canonical + og:url. */
  path: string;
}

/**
 * Per-page metadata. Rendered into <head> at build time by vite-react-ssg's SSG,
 * so each prerendered page ships a unique title/description/canonical/OG.
 */
export function Seo({ title, description, path }: Props) {
  const url = `${SITE_URL}${path}`;
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="JivaSeva" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Head>
  );
}
